module.exports = __webpack_public_path__ + "static/sacramento-hero-river-1f7a951c6e06994eb1ba18b42339ddd3.jpg";